// Polyfill para crypto.randomUUID para navegadores antigos
if (typeof crypto === 'undefined' || !crypto.randomUUID) {
  // Criar um crypto mock se não existir
  if (typeof crypto === 'undefined') {
    window.crypto = {}
  }
  
  // Implementar randomUUID usando Math.random() como fallback
  crypto.randomUUID = function() {
    // Gerar 128 bits (16 bytes) de dados aleatórios
    const randomBytes = new Uint8Array(16)
    for (let i = 0; i < 16; i++) {
      randomBytes[i] = Math.floor(Math.random() * 256)
    }
    
    // Definir versão (4) e variant bits
    randomBytes[6] = (randomBytes[6] & 0x0f) | 0x40 // versão 4
    randomBytes[8] = (randomBytes[8] & 0x3f) | 0x80 // variant 10
    
    // Converter para string hexadecimal
    let hex = ''
    for (let i = 0; i < 16; i++) {
      const byte = randomBytes[i].toString(16).padStart(2, '0')
      hex += byte
    }
    
    // Formatar como UUID: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
    return [
      hex.substring(0, 8),
      hex.substring(8, 12),
      hex.substring(12, 16),
      hex.substring(16, 20),
      hex.substring(20, 32)
    ].join('-')
  }
}

export default crypto
